import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import OpportunityDetailsModal from './OpportunityDetailsModal';

const OpportunityDetailsPage: React.FC = () => {
  const { opportunityId } = useParams<{ opportunityId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const parsedOpportunityId = Number(opportunityId);
  const isIntegration = location.pathname.startsWith('/integration-opportunities');
  const returnPath = isIntegration ? '/integration-opportunities' : '/opportunities';

  if (!parsedOpportunityId) {
    return null;
  }

  return (
    <OpportunityDetailsModal
      opportunityId={parsedOpportunityId}
      mode="page"
      onClose={() => navigate(returnPath)}
    />
  );
};

export default OpportunityDetailsPage;
